import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import Stars from './Stars'
import RatingBreakdown from './RatingBreakdown'

const Rating = ({ rating }) => {
  const { t } = useTranslation(['organisation'])
  return (
    <div className="reputation-management-page__rating">
      <h4 className="reputation-dashboard-tab__overview-title">
        {t('organisation:reputationManagement.rating.averageRating')}
      </h4>
      <div className="reputation-management-page__rating-stars">
        <Stars starsValue={rating.avgRating} />
      </div>
      <RatingBreakdown stats={rating.stats} />
    </div>
  )
}

Rating.propTypes = {
  rating: PropTypes.object,
}

export default Rating
